export default {
  apiUrl: "http://integration.ancia.ca/public/index.php/api",
  apiUrl2: "https://api.app.recruto.ca",
};
